import * as Yup from "yup";
import { States } from "../../../../constants";
import { zipCodeRegEx } from "../../../../utils/RegularExpressions";

export const validStateOptions: string[] = [];
States.forEach((state) => validStateOptions.push(state.name));

export const dealTypeOptions = [
  "Affordable Rental Housing: 4%, 9%",
  "Homeownership",
  "Market Rate Multifamily",
  "Mixed Use",
  "Existing Operating Property",
  "Other",
];

export const constructionTypeOptions = [
  "New Construction",
  "Historic Renovation",
  "Renovation",
  "Adaptive Reuse",
  "In-Place Renovation",
];

export const acquisitionTypeOptions = [
  "Off-Market",
  "On-Market",
  "Joint venture with land owner",
  "Other",
];

export const siteControlStatusOptions = [
  "LOI Obtained",
  "Purchase Contract Executed",
  "RFP Submitted",
  "Exclusive Negotiating Period Entered Into",
  "Other",
];

export const projectByRightOptions = ["Yes", "No", "Not Yet Determined"];

export const validationSchema = Yup.object().shape({
  streetAddress: Yup.string()
    .required("Street Address is required")
    .min(4, "Street Address must be greater than 4 character"),
  city: Yup.string()
    .required("City is required")
    .min(2, "City must be greater than 2 character"),
  state: Yup.string()
    .required("State is required")
    .oneOf(validStateOptions, "You must select a valid option"),
  zipCode: Yup.string()
    .required("Zip / Postal code is required")
    .matches(zipCodeRegEx, "Zip / Postal Code must be a 5 digit number")
    .max(5, "Zip / Postal Code must be 5 digits")
    .min(5, "Zip / Postal Code must be 5 digits"),
  dealType: Yup.string()
    .required("Deal type is required")
    .oneOf(dealTypeOptions, "You must select a valid option"),
  proposedUnits: Yup.number()
    .required("Proposed Number of Units is required")
    .typeError("Proposed Number of Units must be a number")
    .positive("Proposed Number of Units must be greater than 0.")
    .integer("Proposed Number of Units must be whole number not in decimal."),
  constructionType: Yup.string()
    .required("Construction type is required")
    .oneOf(constructionTypeOptions, "You must select a valid option"),
  acquisitionType: Yup.string()
    .required("Acquisition type is required")
    .oneOf(acquisitionTypeOptions, "You must select a valid option"),
  siteControlStatus: Yup.string()
    .required("Status of Site Control is required")
    .oneOf(siteControlStatusOptions, "You must select a valid option"),
  projectByRight: Yup.string()
    .required("Is Proposed Project 'By Right' is required")
    .oneOf(projectByRightOptions, "You must select a valid option"),
  acquisitionCostEstimate: Yup.number()
    .required("Estimated Acquisition Cost is required")
    .typeError("Estimated Acquisition Cost must be a number")
    .positive("Estimated Acquisition Cost must be greater than 0."),
  developmentCostEstimate: Yup.number()
    .required("Estimated Total Development Cost is required")
    .typeError("Estimated Total Development Cost must be a number")
    .positive("Estimated Total Development Cost must be greater than 0"),
  preDevelopmentCostEstimate: Yup.number()
    .required("Estimated Pre-Development Cost is required")
    .typeError("Estimated Pre-Development Cost must be a number")
    .positive("Estimated Pre-Development Cost must be greater than 0"),
  moreInfo: Yup.string()
    .required("More Information About Project is required")
    .min(4, "It must be greater than 4 character"),
});
